import {
    BonusSettlementCustomerStatus,
    BonusSettlementSupplierStatus,
    DemandState,
    DocumentStatus,
    ImportSupplierStatus,
    InquiryOfferState,
    SalesOrderStatus,
} from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { getDocumentStatusTranslationId } from '@synergy/utils';

import { PoolSelect } from '../../select';
import { useFilter } from '../context';

export interface StatusFilterProps {
    documentStatus?:
        | DocumentStatus[]
        | DemandState[]
        | InquiryOfferState[]
        | SalesOrderStatus[]
        | BonusSettlementSupplierStatus[]
        | BonusSettlementCustomerStatus[]
        | ImportSupplierStatus[];
}

export const StatusFilter = (props: StatusFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (
        status?:
            | DocumentStatus
            | DemandState
            | InquiryOfferState
            | SalesOrderStatus
            | BonusSettlementSupplierStatus
            | BonusSettlementCustomerStatus
            | ImportSupplierStatus
    ) => {
        filter.delete('status');
        if (status) {
            filter.set('status', status);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (statusValue: unknown): ReactNode => {
        if (typeof statusValue !== 'string') {
            return '';
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const status = statusValue as
            | DocumentStatus
            | DemandState
            | InquiryOfferState
            | BonusSettlementSupplierStatus
            | BonusSettlementCustomerStatus
            | ImportSupplierStatus;
        return (
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            <FormattedMessage id={getDocumentStatusTranslationId(status)} />
        );
    };

    registerFilterMap('status', getDisplayValue);

    const selectableStatus = props.documentStatus ?? Object.values(DocumentStatus);

    return (
        <PoolSelect
            displayEmpty={true}
            name="status"
            label={<FormattedMessage id="app.filter.statusLabel" />}
            fullWidth={true}
            value={filter.get('status')}
            onValueChange={onSelected}
            noSorting={true}
            options={selectableStatus.map(status => {
                return {
                    value: status,
                    displayValue: <FormattedMessage id={getDocumentStatusTranslationId(status)} />,
                };
            })}
        />
    );
};
